import { useEffect, useState } from "react";
import { Button } from "carbon-components-react";

import DealModal from "./DealModal";
import ChampButton from "../../commons/form/button";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { successToast } from "../../commons/toast";
import DealReedeemedModal from "./DealRedeemedModal";
import RedeemedTodayModal from "./AlreadyRedeemedToday";
import ViewConditionPopup from '../deal-description/UnlockModal'
import { clearStorage, getStorageItem } from "../../utils/sessionStorage";
import { Helmet } from "react-helmet";
// import LockIcon from '@mui/icons-material/Lock';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import React from "react";
import './singlegift.scss'
export default function SingleGift(props) {
  const { deal } = props;
  const accessToken = getStorageItem("token");
  const userId = getStorageItem("user_id");
  const navigate = useNavigate();
  const [userRuns, setUserRuns] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showModalForRedeemed, setShowModalForRedeemed] = useState(false);
  const [redeemedToday, setRedeemedToday] = useState(false);
  const [discountPresent, setDiscountPresent] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [availabledeal, setavailableDeal] = useState("100");
  const [openRedeemedModal, setOpenRedeemedModal] = useState(false);
  const handleOpenRedeemedModal = () => setOpenModal(true);
  const handleCloseRedeemedModal = () => setOpenRedeemedModal(false);
  const [viewUnlockCondition, setViewUnlockCondition] = useState(false);
  // const [lockIconPresent, setLockIconPresent] = useState(true);   
  const getRuns = () => {
    if (!accessToken) return;
    if (!userId) return console.error("userId required");

    const getTotalRun = {
      method: "GET",
      url: global.config.ROOTURL.prod + "/pitch/getTotalRun/" + userId,
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    };
    axios(getTotalRun)
      .then((response) => {
        setUserRuns(response.data);
      })
      .catch((error) => {
        console.log("2")
        console.log(error);
      });
  };
  let DealId;
  const getDealId = (id) => {
    DealId = id;
    window.location.href = `/getDealById/${id}`
  }
  const redeemDeal = (name, email, mobile) => {
    if (name && email && mobile && deal._id) {
      const dealRedeemed = {
        method: "post",
        url: global.config.ROOTURL.prod + "/auth/redeemDeal",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        data: {
          dealId: deal._id,
          name: name,
          email: email,
          mobile: mobile, comingSoon: deal?.comingSoon
        },
        json: true,
      };

      if (userRuns >= deal.redeemrun) {
        axios(dealRedeemed)
          .then((response) => {
            if (response.data.message === 'redeemedtoday') {
              setShowModalForRedeemed(!showModalForRedeemed)
              setShowModal(!showModal)
              setRedeemedToday(true)
              setOpenRedeemedModal(false)
              handleCloseRedeemedModal()
            }
            else {
              setRedeemedToday(false)
            }
          })
          .then(() => handleToggle())
          .then(() => {
            if (!redeemedToday) {
              setOpenRedeemedModal(true);
            }
          })
          .catch((error) => {
            if (error?.response?.status === 401) {
              clearStorage();
              navigate("/login");
            }
          });
      }
    }
  };

  const handleOnClick = () => {
    // handleToggle();
  };

  const handleViewUnlockCondition = () => {
    setViewUnlockCondition(!viewUnlockCondition);
  };


  const handleToggle = () => {
    setShowModal(!showModal);
  };
  const handleCloseRedeemedToday = () => {
    setShowModalForRedeemed(!showModalForRedeemed)
  }
  const navigateToDealDescription = (id) => {
    navigate(`/deal-description/${id}`);
  };
  const [remainingTime, setRemainingTime] = useState(0);

  useEffect(() => {
    if(deal.categories === "TimeLimit"){
      const calculateRemainingTime = () => {
        console.log("deal?.startDateAndTime,deal?.endDateAndTime", deal?.startDateAndTime, deal?.endDateAndTime)
        const startTime = new Date(deal?.startDateAndTime).getTime();
        const endTime = new Date(deal?.endDateAndTime).getTime();
  
        const currentDate = new Date();
        currentDate.setHours(currentDate.getHours() + 5);
  
        currentDate.setMinutes(currentDate.getMinutes() + 30);
        const currentTime = currentDate.getTime();
        if (currentTime < startTime) {
          setRemainingTime(startTime - currentTime);
        } else if (currentTime > endTime) {
          setRemainingTime(0);
        } else {
          setRemainingTime(endTime - currentTime);
        }
      };
      const interval = setInterval(calculateRemainingTime, 1000);
  
      return () => {
        clearInterval(interval);
      };
    }
    
  }, [deal?.startDateAndTime, deal?.endDateAndTime]);
  const formatTime = (time) => {
    const days = Math.floor(time / (1000 * 60 * 60 * 24));
    const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((time / (1000 * 60)) % 60);
    const seconds = Math.floor((time / 1000) % 60);

    const formattedDays = days.toString().padStart(2, '0');
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = seconds.toString().padStart(2, '0');

    // return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;

    if (days > 0) {
      return `${formattedDays}:${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    } else {
      return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    }
  };

  const currentDateTime = new Date();
  currentDateTime.setHours(currentDateTime.getHours() + 5);

  currentDateTime.setMinutes(currentDateTime.getMinutes() + 30);
  const calculateOffPrice = (redeemrun, discount) => {

    return Math.round(redeemrun * discount / 100);
  }

  const calculatePriceAfterDiscount = (redeemrun, discount) => {

    return Math.round(redeemrun - redeemrun * discount / 100);
  }
  useEffect(() => {
    getRuns();


  }, []);
  return (
    <>
      <Helmet>
        <title>Champhunt | Deals</title>
      </Helmet>
      <div className="deal-giftContainer">
        {deal.categories === "TimeLimit" &&
          deal?.discount > 0 &&
          new Date(deal?.discountStartDateAndTime) <= currentDateTime &&
          new Date(deal?.discountEndDateAndTime) >= currentDateTime ? (
          <div
            style={{ backgroundImage: `url(${deal?.dealImage})` }}
            className="deal-container"
          >
            <div className="timer-section">
              <span className="timer-text">Limited Time   </span><span className="timer-text">{formatTime(remainingTime)}</span>

            </div>
            <div className="blue-overlay__wrapper">
              <div className="blue-corner-overlay">
                <span className="overlay-text">
                  -{calculateOffPrice(deal?.redeemrun, deal?.discount)} OFF
                </span>
              </div>
            </div>
          </div>
        ) : deal.categories === "TimeLimit" ? (
          <div
            style={{ backgroundImage: `url(${deal?.dealImage})` }}
            className="deal-container"
          >
            <div className="timer-section">
              <span className="timer-text">Limited Time   </span><span className="timer-text">{formatTime(remainingTime)}</span>

            </div>
          </div>
        ) : deal.categories === "Exclusive" &&
          deal?.discount > 0 &&
          new Date(deal?.discountStartDateAndTime) <= currentDateTime &&
          new Date(deal?.discountEndDateAndTime) >= currentDateTime ? (
          <div
            style={{ backgroundImage: `url(${deal?.dealImage})` }}
            className="deal-container"
          >
            <div className="blue-overlay__wrapper">
              <div className="blue-corner-overlay">
                <span className="overlay-text" style={{ marginLeft: "-16px" }}>
                  EXCLUSIVE
                </span>
                <span className="overlay-text">
                  -{calculateOffPrice(deal?.redeemrun, deal?.discount)} OFF
                </span>
              </div>
            </div>
          </div>
        ) : deal.categories === "Exclusive" ? (
          <div
            style={{ backgroundImage: `url(${deal?.dealImage})` }}
            className="deal-container"
          >
            <div className="blue-overlay__wrapper">
              <div className="blue-corner-overlay">
                <span className="overlay-text">EXCLUSIVE</span>
              </div>
            </div>
          </div>
        ) : deal?.discount > 0 &&
          new Date(deal?.discountStartDateAndTime) <= currentDateTime &&
          new Date(deal?.discountEndDateAndTime) >= currentDateTime ? (
          <div
            style={{ backgroundImage: `url(${deal?.dealImage})` }}
            className="deal-container"
          >
            <div className="blue-overlay__wrapper">
              <div className="blue-corner-overlay">
                <span className="overlay-text">
                  -{calculateOffPrice(deal?.redeemrun, deal?.discount)} OFF
                </span>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <img src={deal.dealImage} alt="" className="deal-giftImage" />
          </div>
        )}

        {deal?.isLocked && !deal?.unlockedByUser && (
          <button className="lock_main_btn" onClick={handleViewUnlockCondition}>
            <LockOutlinedIcon className="lock_icon" />
          </button>
        )}
        <div className="deal-giftcontent">
          <div className="deal-reamininggiftcontainer">
            <div
              className="deal-reamaning"
              style={{
                width: deal.count > 0 ? `${(deal.count * 100) / deal.totalDeal}%` : '0%'
              }}
            ></div>
          </div>
          <div>
            <p className="deal-giftFont">{deal.name}</p>
          </div>
          <div className="deal-giftbuttoncontent">
            {deal?.discount > 0 &&
              new Date(deal?.discountStartDateAndTime) <= currentDateTime &&
              new Date(deal?.discountEndDateAndTime) >= currentDateTime ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <p className="discount-price">{deal.redeemrun}</p>
                <p className="deal-giftFont ">
                  {calculatePriceAfterDiscount(deal?.redeemrun, deal?.discount)} runs
                </p>
              </div>
            ) : (
              <p className="deal-giftFont">{deal.redeemrun} runs</p>
            )}

            {deal.count ? (
              deal?.comingSoon ? (
                <Button className="giftButton-deal1" disabled={true}>
                  Coming Soon
                </Button>
              ) : (
                deal.isLocked && !deal.unlockedByUser ? (
                  <Button className="giftButton-deal1" disabled={true}>
                    Locked
                  </Button>
                ) : (
                  <Button
                    className="giftButton-deal"
                    onClick={() => navigateToDealDescription(deal._id)}
                  >
                    Redeem Now
                  </Button>
                )
              )
            ) : (
              <Button className="giftButton-deal1" disabled={true}>
                Out of Stock
              </Button>
            )}

          </div>
        </div>
      </div>
      {showModal && (
        <DealModal
          handleClose={handleToggle}
          deal={deal}
          open={showModal}
          redeemDeal={redeemDeal}
        />
      )}
      {showModalForRedeemed && (
        <RedeemedTodayModal
          handleClose={handleCloseRedeemedToday}
          open={showModalForRedeemed}
        />
      )}
      {!redeemedToday && (
        <DealReedeemedModal
          handleClose={handleCloseRedeemedModal}
          handleOpen={handleOpenRedeemedModal}
          open={openRedeemedModal}
        />
      )}

      {viewUnlockCondition && (
        <ViewConditionPopup
          open={viewUnlockCondition}
          handleClose={handleViewUnlockCondition}
          condition={deal?.conditionForUnlock}
          count={deal?.currentCount}
        />
      )}
    </>
  );
}

